// extracted by mini-css-extract-plugin
export var content = "image-link-blocks-module--content--8b36e";
export var flex = "image-link-blocks-module--flex--5e0d0";
export var half = "image-link-blocks-module--half--6049a";
export var linkBlocks = "image-link-blocks-module--link-blocks--b77aa";
export var third = "image-link-blocks-module--third--f71d9";